import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';
import { pxToVW } from '@/utils/pxToVW';

export default class Text extends Component {
  getClass = (size) => {
    let textClass = 'default-text';
    switch (size) {
      case 'huge':
        textClass = 'huge-text';
        break;
      case 'big':
        textClass = 'big-text';
        break;
      case 'large':
        textClass = 'large-text';
        break;
      case 'small':
        textClass = 'small-text';
        break;
      default:
        break;
    }
    return textClass;
  }

  renderText = (text) => {
    if (!_.isEmpty(text)) {
      const desc = text.split('+&+');
      return desc.map((item, index) => {
        if (_.isEmpty(item)) {
          return (<></>)
        }
        return (<p key={index}>{item}</p>)
      })
    }
    return text;
  }

  render() {
    const { text, size = 'default', textAlign, fontSize, fontWeight, lineHeight, style, href, target, cid, vid, nativePage, nativePath, externalUrl, handleChangePage, router, event = 'doNothing' } = this.props;
    const newFontSize = fontSize && pxToVW({ fontSize });
    let textStyle = _.omitBy(Object.assign({}, { textAlign, fontWeight, lineHeight }, newFontSize, style), _.isUndefined);
    const textClass = this.getClass(size);
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target)) ? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openNativeView') {
      params = { nativePage, externalUrl }
    }
    if (event === 'shareAndGrantCoupon') {
      const { shareInfo, modalInfo } = this.props;
      params = { shareInfo, modalInfo };
    }
    if (event === 'openAudio') {
      params = !_.isNil(cid) ? { cid } : {}
    }
    if (event === 'openVideoChannel') {
      params = { nativePath }
    }
    if (event === 'openReader') {
      params = { nativePath }
    }
    const clickEvent = !_.isEmpty(event) ? (event !== 'navLink' ? function () { CrgtEvent[`${event}`](params) } : () => { handleChangePage && handleChangePage(router) }) : null;
    // return React.createElement('div', { 'className': textClass, style: style }, text);
    return (<div className={textClass} style={textStyle} onClick={clickEvent}>{
      this.renderText(text)
    }</div>)
  }
}